export enum IPRangeMeta {
  MODEL = "iprange",
  PK = "id",
}

export enum IPRangeType {
  Dynamic = "dynamic",
  Reserved = "reserved",
}
